const Data = {
  'Básico':
    [
      {
        id: "Básico_Carpintería",
        name: "Carpintería",
        category: "finishesWoodwork",
        options: [
          {
            id: "Básico_Carpintería_Madera",
            name: "Madera",
            price: '0',
            included: true,
            quote_text: 'Carpintería - Madera',
            image: require("../assets/images.jpg")
          },
          {
            id: "Básico_Carpintería_Grafito",
            name: "Grafito",
            price: '5,000,000',
            included: false,
            quote_text: 'Carpintería - Grafito',
            image: require("../assets/Carpinteria_darkSteel.jpg")
          },
        ]
      },
      {
        id: "Básico_Piso",
        name: "Piso",
        category: "finishesFloor",
        options: [
          {
            id: "Básico_Piso_Madera",
            name: "Madera",
            price: '4,200,000',
            included: true,
            quote_text: 'Piso - Madera',
            image: require("../assets/Piso_Madera.jpg")
          },
          {
            id: "Básico_Piso_Concreto",
            name: "Concreto",
            included: false,
            price: '6,000,000',
            quote_text: 'Piso - Concreto',
            image: require("../assets/Piso_Concreto.jpg")
          },
        ]
      },
      {
        id: "Básico_Mesón",
        name: "Mesón",
        category: "finishesMeson",
        options: [
          {
            id: "Básico_Mesón_Blanco",
            name: "Blanco",
            price: '3,500,000',
            included: true,
            quote_text: 'Mesón - Blanco',
            image: require("../assets/Meson_Quarztone_gris.jpg")
          },
          {
            id: "Básico_Mesón_Grafito",
            name: "Grafito",
            price: '3,600,000',
            included: false,
            quote_text: 'Mesón - Grafito',
            image: require("../assets/Carpinteria_darkSteel.jpg")
          },
        ]
      },
    ],
  'Desmontable':
    [
      {
        id: "Desmontable_Baranda",
        name: "Baranda",
        category: "finishesRail",
        options: [
          {
            id: "Desmontable_Baranda_Malla",
            name: "Malla",
            price: '1,400,000',
            included: false,
            quote_text: 'Baranda - Malla',
            image: require("../assets/Baranda_Malla.jpg")
          },
          {
            id: "Desmontable_Baranda_Policarbonato",
            name: "Policarbonato",
            price: '2,100,000',
            included: false,
            quote_text: 'Baranda - Policarbonato',
            image: require("../assets/Baranda_Policarbonato.jpg")
          },
        ]
      },
      {
        id: "Desmontable_Carpintería",
        name: "Carpintería",
        category: "finishesWoodwork",
        options: [
          {
            id: "Desmontable_Carpintería_Madera",
            name: "Madera",
            price: '0',
            included: true,
            quote_text: 'Carpintería - Madera',
            image: require("../assets/images.jpg")
          },
          {
            id: "Desmontable_Carpintería_Grafito",
            name: "Grafito",
            price: '5,000,000',
            included: false,
            quote_text: 'Carpintería - Grafito',
            image: require("../assets/Carpinteria_darkSteel.jpg")
          },
        ]
      },
      {
        id: "Desmontable_Piso",
        name: "Piso",
        category: "finishesFloor",
        options: [
          {
            id: "Desmontable_Piso_Madera",
            name: "Madera",
            price: '4,200,000',
            included: true,
            quote_text: 'Piso - Madera',
            image: require("../assets/Piso_Madera.jpg")
          },
          {
            id: "Desmontable_Piso_Concreto",
            name: "Concreto",
            price: '6,000,000',
            included: false,
            quote_text: 'Piso - Concreto',
            image: require("../assets/Piso_Concreto.jpg")
          },
        ]
      },
      {
        id: "Desmontable_Mesón",
        name: "Mesón",
        category: "finishesMeson",
        options: [
          {
            id: "Desmontable_Mesón_Blanco",
            name: "Blanco",
            price: '3,500,000',
            included: true,
            quote_text: 'Mesón - Blanco',
            image: require("../assets/Meson_Quarztone_gris.jpg")
          },
          {
            id: "Desmontable_Mesón_Grafito",
            name: "Grafito",
            price: '3,600,000',
            included: true,
            quote_text: 'Mesón - Grafito',
            image: require("../assets/Carpinteria_darkSteel.jpg")
          },
        ]
      },
    ]
  }


module.exports = { Data };